import { __exports as e } from "./index122.js";
import { __require as l } from "./index115.js";
import { __require as n } from "./index88.js";
var i;
function p() {
  if (i) return e;
  i = 1;
  var u = e && e.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Delete = void 0;
  var _ = u(l()), a = n();
  function t(r, o) {
    a.Facade.call(this, r, o);
  }
  return e.Delete = t, _.default(t, a.Facade), t.prototype.type = function() {
    return "delete";
  }, e;
}
export {
  p as __require
};
//# sourceMappingURL=index95.js.map
